import axios from 'axios';

const BASE = 'https://dawn-paper-ec4a.ovoowovo.workers.dev';

export async function getDailyHours(dateString) {
	const res = await axios.get(`${BASE}/daily-hours?date=${encodeURIComponent(dateString)}`);
	return res.data;
}

export async function getDaily(dateString) {
	const res = await axios.get(`${BASE}/daily?date=${encodeURIComponent(dateString)}`);
	return res.data;
}

export async function getPlayerStats(page = 1, pageSize = 10, search = '') {
	const params = new URLSearchParams({ page, pageSize });
	if (search) params.append('search', search);
	const res = await axios.get(`${BASE}/player-stats?${params.toString()}`);
	return res.data;
}

export async function searchUser(search = '') {
	const res = await axios.get(`${BASE}/search-user?search=${encodeURIComponent(search)}`);
	return res.data;
}


const api = { getDailyHours, getDaily, getPlayerStats, searchUser };
export default api;
